import { useEffect, useRef } from 'react';

import { Box, Checkbox } from '@mui/material';

import moment from 'moment';
import CircleIcon from '@mui/icons-material/Circle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function SubmissionCard ({
  user,
  selected,
  onToggle,
}: {
  user: any;
  selected: boolean;
  onToggle: (submissionId: string) => void;
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && selected !== ref.current.checked) {
      console.log(1);
      ref.current.click();
    }
  }, [selected]);

  return (
    <Box width="280px" key={user.uid} position="relative">
      <img
        src={(process.env.REACT_APP_S3_URL ?? '') + user.submissions[0].image_url }
        width="280px"
        height="280px"
        style={{ objectFit: 'cover', border: selected ? '4px solid #006EC2' : 'none' }}
        onClick={() => {
          ref.current.click();
        }}
        alt=""
      />
      <Checkbox
        icon={<CircleIcon sx={{ fill: '#FFFFFF80' }} />}
        checkedIcon={<CheckCircleIcon sx={{ fill: '#006EC2' }} />}
        sx={{ position: 'absolute', top: '0', right: '0' }}
        onChange={_ => {
          if (selected !== ref.current.checked) {
            onToggle(user.submissions[0]._id);
          }
        }}
        inputRef={ref}
      />
      <div style={{ marginTop: '10px', fontSize: '19px', color: '#006EC2' }}>{user.uid}</div>
      <div style={{ fontSize: '14px' }}>
        {'Upload Time: ' + moment(user.submissions[0]?.timestamp).format('DD/MM/YYYY HH:MM')}
      </div>
    </Box>
  );
}
